module.exports = __webpack_public_path__ + "img/azg_1@2x.eedf75ae.png";